export var IngestionPipelineStatus;
(function (IngestionPipelineStatus) {
    IngestionPipelineStatus["INGESTION_PIPELINE_STATUS_CREATING"] = "CREATING";
    IngestionPipelineStatus["INGESTION_PIPELINE_STATUS_CREATE_FAILED"] = "CREATE_FAILED";
    IngestionPipelineStatus["INGESTION_PIPELINE_STATUS_STOPPED"] = "STOPPED";
    IngestionPipelineStatus["INGESTION_PIPELINE_STATUS_STARTING"] = "STARTING";
    IngestionPipelineStatus["INGESTION_PIPELINE_STATUS_STARTED"] = "STARTED";
    IngestionPipelineStatus["INGESTION_PIPELINE_STATUS_STOPPING"] = "STOPPING";
    IngestionPipelineStatus["INGESTION_PIPELINE_STATUS_UPDATING"] = "UPDATING";
    IngestionPipelineStatus["INGESTION_PIPELINE_STATUS_RESETTING"] = "RESETTING";
    IngestionPipelineStatus["INGESTION_PIPELINE_STATUS_DELETING"] = "DELETING";
})(IngestionPipelineStatus || (IngestionPipelineStatus = {}));
